









































import UserRoleLocations from '@/views/users/components/UserRoleLocations';
import UserInfoForm from '@/views/users/components/UserInfoForm.ts';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { UserData, UserInfoField, AppMetadata } from '@/views/users/Users';
import { Role } from 'auth0';

const Tenants = namespace('tenants');

@Component({
  components: {
    UserRoleLocations,
    UserInfoForm
  }
})
export default class UserView extends Vue {
  
  private data: UserData = {};
  
  private userActivityFields: { [keyName: string]: UserInfoField } = {
    logins_count: {
      label: 'Total Logins',
      type: 'input',
      readonly: true
    },
    last_login: {
      label: 'Last Login',
      type: 'input',
      readonly: true,
      filters: 'fullDate'
    },
    last_ip: {
      label: 'Last IP',
      type: 'input',
      validate: 'required'
    },
    created_at: {
      label: 'Created at',
      type: 'input',
      validate: 'required',
      filters: 'fullDate'
    },
    updated_at: {
      label: 'Last update',
      type: 'input',
      validate: 'required',
      filters: 'fullDate'
    },
    email_verified: {
      label: 'Email verified',
      type: 'input',
      validate: 'required'
    }
  }
  
  @Tenants.Action('getUser')
  private getUser!: (userId: string) => Promise<UserData>
  
  @Tenants.Action('saveUser')
  private saveUser!: (data: UserData) => Promise<UserData>
  
  @Tenants.Action('sendResetPassword')
  private sendResetPassword!: (data: UserData) => Promise<UserData>
  
  private async saveChanges () {
    const result = await this.saveUser(this.data);
    if (result) this.data = result;
  }
  
  private onResetPassword () {
    this.sendResetPassword(this.data);
  }
  
  private onUpdateRoles (app_metadata: AppMetadata, location: any) {
    this.saveUser({
      ...this.data,
      app_metadata
    })
  }
  
  async created () {
    this.data = await this.getUser(this.$route.params.id);
  }
}
